import { Input } from "../../../../../../components/Input/Input";
import { TableColumn } from "../../../../../../components/ModularDataTable";
import { i18n } from "../../../../../../translate/i18n";
import { ProductMappingType } from "../type";


export const createColumns = ({ switchStatus, isWholeSaler }: any): TableColumn[] => {
    const columns: TableColumn[] = [
        { key: i18n.t(`smart_order.code`), value: 'code', type: 'text', sortable: true },
        {
            key: i18n.t(`smart_order.image`), value: 'img', type: 'custom', render(value, row) {
                return <img src={row.img} alt={value} style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }} />
            }
        },
        { key: i18n.t(`smart_order.name`), value: 'name', type: 'text', sortable: true },
        {
            key: i18n.t(`smart_order.category`),
            value: 'category',
            type: 'text',
            sortable: false,
        },
        {
            key: 'Status',
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: ProductMappingType) => (
                <div className='mt-5'>
                    <Input
                        value={row.status}
                        checked={row.status}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
        {
            key: i18n.t(`smart_order.created`),
            value: 'created',
            type: 'datetime',
            sortable: true,
            visible: false
        },
        {
            key: i18n.t(`smart_order.updated`),
            value: 'updated',
            type: 'datetime',
            sortable: true,
             visible: false
        }

    ]

    if (isWholeSaler) {
        columns.push({
            key: 'Grupo',
            value: 'group',
            type: 'custom',
            render: (value: string[]) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {value.length > 0 ? (
                            value.map((group, index) => (
                                <span key={index} className='badge badge-primary flex justify-content-center align-items-center'>
                                    {group}
                                </span>
                            ))
                        ) : (
                            <span className='badge badge-light flex justify-content-center align-items-center'>SEM GRUPO</span>
                        )}
                    </div>
                )
            },
        })
    }

    return columns
}


export const createColumnsModalGrupo = (): TableColumn[] => {
    const columns: TableColumn[] = [
        { key: i18n.t(`smart_order.code`), value: 'code', type: 'text', sortable: true },
        {
            key: i18n.t(`smart_order.image`), value: 'img', type: 'custom', render(value, row) {
                return <img src={row.img} alt={value} style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }} />
            }
        },
        { key: i18n.t(`smart_order.name`), value: 'name', type: 'text', sortable: true },
        {
            key: i18n.t(`smart_order.category`),
            value: 'category',
            type: 'text',
            sortable: false,
        },
        {
            key: 'Grupo',
            value: 'group',
            type: 'custom',
            render: (value: string[]) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {value.length > 0 ? (
                            value.map((group, index) => (
                                <span key={index} className='badge badge-primary flex justify-content-center align-items-center'>
                                    {group}
                                </span>
                            ))
                        ) : (
                            <span className='badge badge-light flex justify-content-center align-items-center'>SEM GRUPO</span>
                        )}
                    </div>
                )
            },
        }
    ]


    return columns
}